import { user } from "./user";
import { facebook } from "./facebook";
import { languages } from "../plugins/languages";
import CookieHelper from "@/helpers/CookieHelper";
import { SpinLoyErrorCodes } from "@/enum/SpinLoyErrorCodes";
export var settings = {
  mixins: [user, facebook],
  beforeMount() {
    let storeUser = this.$store.state.user;

    let formFields = this.$store.state.config.profile_form_fields;
    Object.keys(this.models).forEach(key => {
      if (formFields[key] === "hidden") {
        delete this.models[key];
        return;
      }

      if (key === "license_plate") {
        this.licensePlateField = {
          id: "license_plate",
          label: this.$t("label.license_plate"),
          type: "text",
          required: this.fieldEqualsDisplay("license_plate", "required"),
          errorMessage: ""
        };
        this.models.license_plate = {
          license_plate:
            storeUser["license_plate"] == null
              ? ""
              : storeUser["license_plate"],
          license_plate_country_code:
            storeUser["license_plate_country_code"] == null
              ? ""
              : storeUser["license_plate_country_code"]
        };
        return;
      }
      this.models[key] = storeUser[key] == null ? "" : storeUser[key];
    });
    if (typeof this.models.birth_date === "string") {
      this.editBirthDate = this.models.birth_date.length === 0;
    }
  },
  data() {
    return {
      editBirthDate: false,
      deleteAccountDialog: false,
      facebookConnectDialog: false,
      changeBankAccountDialog: false,
      overrideUserData: false,
      tab: 0,
      models: {
        site_language: null
      },
      possibleLanguages: {
        id: "site_language",
        choices: [
          { label: "label.dutch", value: "nl_NL" },
          { label: "label.english", value: "en_US" }
        ]
      },
      busyUpdating: false,
      deleteLoading: false,
      changeBankAccountLoading: false
    };
  },

  methods: {
    disagreeFacebookOverride() {
      this.facebookConnectDialog = false;
      this.overrideUserData = false;
      this.facebookConnect();
    },
    agreeFacebookOverride() {
      this.facebookConnectDialog = false;
      this.overrideUserData = true;
      this.facebookConnect();
    },
    async facebookConnect() {
      this.loading = true;
      //request token and permissions from facebook
      let token = await new Promise(resolve =>
        window.FB.login(resolve, { scope: "user_birthday,user_gender" })
      );
      if (!token.authResponse) {
        this.$store.commit("viewstate/notify", {
          text: "iets ging fout bij het ophalen van toegang tot facebook",
          color: "error"
        });
        this.loading = false;
      } else {
        //get user data
        let user_data_promise = await new Promise(resolve =>
          window.FB.api(
            "me",
            {
              fields: ["first_name", "last_name", "email", "birthday", "gender"]
            },
            resolve
          )
        );
        this.$store
          .dispatch("user/facebookConnect", token)
          .then(response => {
            this.$store.commit("user/user", response.data);
            let birthday_array = user_data_promise["birthday"].split(/\//);
            user_data_promise["birth_date"] =
              birthday_array[1] +
              "-" +
              birthday_array[0] +
              "-" +
              birthday_array[2];
            if (this.overrideUserData) {
              this.setFromModel(user_data_promise, this.models);
            }
          })
          .catch(error => {
            let data = error.response.data;
            if (
              data.error !== undefined &&
              data.error === "user_already_connected_to_facebook"
            ) {
              this.$store.commit("viewstate/notify", {
                text: this.$t("error.user_already_connected_to_facebook"),
                color: "error"
              });
              return;
            }
            this.$store.commit("viewstate/notify", {
              text: this.$t("error.something_went_wrong"),
              color: "error"
            });
          });
      }
    },
    updateUser(e) {
      e.preventDefault();
      if (!this.$refs.profileform.validate()) {
        return;
      }
      this.busyUpdating = true;
      this.$store
        .dispatch("user/update", this.removeExtraKeys(this.models))
        .then(response => {
          this.$i18n.locale = this.$i18n.locale = languages[
            response.data.site_language
          ]
            ? languages[response.data.site_language]
            : "nl";
          this.$store.commit("viewstate/notify", {
            text: this.$t("success.update_user"),
            color: "success"
          });
          this.$store.commit("user/user", response.data);
        })
        .catch(error => {
          if (
            error.response.status === 400 &&
            error.response.data.error_code === 46
          ) {
            this.possibleTextFields["license_plate"].errorMessage = this.$t(
              "error.license_plate_is_used"
            );
          } else {
            this.$store.commit("viewstate/notify", {
              text: this.$t("error.update_user"),
              color: "error"
            });
          }
        })
        .finally(() => {
          this.busyUpdating = false;
        });
    },
    removeExtraKeys(object) {
      let newObject = {};
      Object.keys(object).forEach(key => {
        if (
          object[key] === null ||
          object[key] === undefined ||
          object[key] === "" ||
          (key === "birth_date" && !this.editBirthDate)
        ) {
          return;
        }

        if (
          key === "license_plate" &&
          typeof object[key] === "object" &&
          object[key] !== null
        ) {
          const license_plate = object[key]["license_plate"];
          const license_plate_country_code =
            object[key]["license_plate_country_code"] || "";
          if (!license_plate) {
            return;
          }
          newObject["license_plate"] = license_plate;
          if (license_plate_country_code) {
            newObject[
              "license_plate_country_code"
            ] = license_plate_country_code;
          }
          return;
        }

        newObject[key] = object[key];
      });
      return newObject;
    },
    fieldEqualsDisplay(id, display) {
      const value = this.$store.state.config.profile_form_fields[id];
      return (value !== undefined ? value : "hidden") === display;
    },
    deleteAccount() {
      this.deleteLoading = true;
      this.$store
        .dispatch("user/delete")
        .then(response => {
          if (response.status !== 204) {
            return;
          }
          CookieHelper.unsetCookie("user");
          localStorage.removeItem("authorized");
          this.$router.push("login");
        })
        .catch(error => {
          if (
            error &&
            error.response &&
            error.response.data &&
            error.response.data.code &&
            error.response.data.code ===
              SpinLoyErrorCodes.CUSTOMER_HAS_ACTIVE_SUBSCRIPTIONS
          ) {
            this.$store.commit("viewstate/notify", {
              text: this.$t("error.customer_has_active_subscriptions"),
              color: "error"
            });
            return;
          }
          this.$store.commit("viewstate/notify", {
            text: this.$t("error.something_went_wrong"),
            color: "error"
          });
        })
        .finally(() => {
          this.deleteLoading = false;
        });
    },
    stopAccountDeletion() {
      this.deleteAccountDialog = false;
    },
    keyupEvent(field_id) {
      if (field_id === "license_plate") {
        this.models[field_id] = this.models[field_id].toUpperCase();
      }
    },
    handleChangeBankAccount() {
      this.changeBankAccountLoading = true;
      this.$store.dispatch("user/changeBankAccount").finally(() => {
        this.changeBankAccountLoading = false;
      });
    }
  },
  computed: {
    editBirthDateMessage() {
      return this.editBirthDate
        ? this.$t("info.edit_birth_date", {
            organization_name: this.$store.state.config.name
          })
        : this.$t("info.cant_edit_birth_date", {
            organization_name: this.$store.state.config.name
          });
    },
    tabItems() {
      let tabItems = [
        {
          key: "settings",
          translation: "tab.settings",
          icon: "mdi-account-edit"
        },
        {
          key: "deactivate",
          translation: "tab.deactivate",
          icon: "mdi-account-remove"
        }
      ];
      if (this.$store.state.config.template_settings.show_anonymous_cards) {
        tabItems.splice(1, 0, {
          key: "anonymous_cards",
          translation: "tab.anonymous_cards",
          icon: "mdi-barcode-scan"
        });
      }
      return tabItems;
    }
  }
};
